import type { ReactNode } from 'react'
import { useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import { ProductTour } from '@/components/shared/ProductTour'
import { TooltipProvider } from '@/components/ui/tooltip'

import { AppSidebar } from './AppSidebar'
import { AppTopbar } from './AppTopbar'

interface AppLayoutProps {
  children?: ReactNode
}

export function AppLayout({ children }: AppLayoutProps) {
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false)
  const { pathname } = useLocation()

  return (
    <TooltipProvider delayDuration={300}>
      <div className="h-screen flex w-full bg-muted overflow-hidden">
        <AppSidebar mobileOpen={mobileSidebarOpen} onMobileOpenChange={setMobileSidebarOpen} />
        <div className="flex-1 flex flex-col w-full overflow-auto">
          <AppTopbar onOpenMobileSidebar={() => setMobileSidebarOpen(true)} />
          <main
            key={pathname}
            className="flex-1 bg-background m-3 rounded-lg border border-border shadow-sm animate-page-enter"
            data-tour="main-content"
          >
            {children ?? <Outlet />}
          </main>
        </div>
      </div>
      <ProductTour />
    </TooltipProvider>
  )
}
